import { serviceNamePlaceholder } from 'components/shared/helpers'

export const ConsentConstants = {
  Title: `${serviceNamePlaceholder} wants to access your Paddle account`,
  Subtitle: `This will allow ${serviceNamePlaceholder} to access:`,
  LearnMore: `You will be sharing sensitive data with ${serviceNamePlaceholder}. Learn about how ${serviceNamePlaceholder} will use your data here. You can see or remove access in your ${serviceNamePlaceholder} account.`,
  Cancel: 'Cancel',
  CTA: 'Allow',
}
